<template>
<!--below eliminates need to state event.preventDefault() in ever click handler-->
    <form v-on:submit.prevent>
    <div id="root">
        <div id="mainColumn">
            <div id="header">
                <img id="home" alt="martinLogo" src="../assets/martin.png" style="border-radius: 10px;">
                <h1>Martin Burnell</h1>
                <div class="clickable" @click="linkedInHandler">LinkedIn</div>
                <div class="clickable" @click="emailHandler">Email</div>
                <div class="clickable" @click="pdfHandler">Resume</div>
            </div>
            <div class="sectionContainer">
                <div class="titleContainer" @click="animateSection">
                    <span id="about" class="sectionTitle">About</span>
                </div>
                <div class="sectionContentContainer">
                    <div id="aboutContent">
                        <p>I created this website to test out new frameworks/tools and to showcase some of my work.</p>
                        <p>I used Vue.js to create the website and I am hosting it on a Google Compute Engine VM instance.</p>
                        <p>The active background is a <a @click="particlesJSHandler">Particle.js</a> configuration. Make sure to give it a click!</p>
                        <p>Feel free to <a @click="emailHandler">contact me</a> with questions, comments, or whatever!</p>
                    </div>
                </div>
            </div>
            <div class="sectionContainer">
                <div class="titleContainer" @click="animateSection">
                    <span id="projects" class="sectionTitle">Projects</span>
                </div>
                <div class="sectionContentContainer">
                    <div class="projectContainer">
                        <div>
                            <div class="projectTitle"  title="link to Google Play">The Ate Ball</div>
                            <div>
                                <img  @click="ateBallHandler" id="ateBallImg" class="clickableImg" alt="ateBallImg" src="../assets/8ball_icon.png" title="link to Google Play">
                            </div>
                        </div>
                        <div class="projectContent">
                            <p>
                              The Ate Ball started off as a learning project to help me improve my coding skills and learn the Android environment, but as time went
                                I found I enjoyed using it and so I published it.
                            </p>
                            <p>
                              The purpose of the app is to help users decide what/where to eat. I wanted the process to be engaging and entertaining so there is a large emphasis on interaction
                                in the app.
                            </p>
                          <p>
                            If you want to try it out just click the image above!
                          </p>
                        </div>
                    </div>
                    <div class="projectContainer">
                        <div>
                            <div class="projectTitle">This</div>
                            <div>
                                <img id="websiteImage" alt="ateBallImg" src="../assets/spidey.png" title="You're already here!">
                            </div>
                        </div>
                        <div class="projectContent">
                            <p>
                              Believe it or not, this website is in fact a project of mine!
                            </p>
                          <p>
                            As mentioned above, Vue.js was the chosen framework for the site and I used JavaScript and CSS to create all the functionality and animations.
                          </p>
                          <p>
                            The site is hosted on a Google Compute Engine instance which is using a Debian operating system and an
                            <a class="clickableContent" @click="apacheHandler">Apache HTTP Sever</a> to serve the site content.
                          </p>
                          <p>
                            I plan on adding more to the site in the future and I will make sure to add links to all my relevant work as they become available.
                          </p>
                          <p>
                            If you have any questions on the site or have any suggestions just let me know!
                          </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sectionContainer">
                <div class="titleContainer"  @click="animateSection">
                    <span id="whyNotTitle" class="sectionTitle" v-show="showZoid">Why Not?</span>
                </div>
                <div class="sectionContentContainer">
                    <img class="clickableImg"  id="whyNotZoidberg" v-show="showZoid" @click="whyNotHandler" alt="whyNot" src="../assets/WhyNot.png" style="padding: 5px; border-radius: 20px">
                </div>
            </div>
        </div>
        <div id="rightColumn" class="navBar">
            <div>
                <a href="#home">Home</a>
            </div>
            <div>
                <a href="#about">About</a>
            </div>
            <div>
                <a href="#projects">Projects</a>
            </div>
        </div>
    </div>
    </form>
</template>

<script>
    export default {
        name: 'Home',
        props: {
            msg: String
        },
        data:function() {
            return {
                showZoid: true
            };
        },
        methods:{
            ateBallHandler(){
                window.open("https://play.google.com/store/apps/details?id=com.thecornfiles.martymane.theateball");
            },
            whyNotHandler(){
                window.open("https://www.youtube.com/watch?v=dQw4w9WgXcQ");
            },
            pdfHandler(){
                window.open("Resume.pdf");
            },
            emailHandler(){
                window.location.href = "mailto:martin@itsmartin.net";
            },
            linkedInHandler(){
                window.open("https://linkedin.com/in/martin-burnell-b5a78088");
            },
            particlesJSHandler(){
                window.open("https://vincentgarreau.com/particles.js/");
            },
            apacheHandler(){
                window.open("https://httpd.apache.org");
            },
            animateSection(event){
              // console.log("event: ", event);
              let animationTime = 500;
              if(event && event.target) {
                //console.log("target: ", event.target);
                let sectionContainer = event.target.closest(".sectionContainer");
                let sectionContentWrapper = sectionContainer.getElementsByClassName("sectionContentContainer")[0];
                //console.log("sectionContentWrapper: ", sectionContentWrapper);
                if(sectionContentWrapper.classList.contains("section-has-animated")){
                  sectionContentWrapper.classList.remove("section-has-animated");
                  let draw = (timer) => {
                    let proportion = timer / animationTime;
                    let height = sectionContentWrapper.scrollHeight - Math.floor(sectionContentWrapper.scrollHeight * proportion);
                    sectionContentWrapper.style.height = height + "px";
                    sectionContentWrapper.style.opacity = (1 - proportion) + "";
                  }
                  //this creates the function that animates the titles and section contents
                  const start = Date.now();
                  let timer = setInterval(function () {
                    // how much time passed from the start
                    let timePassed = Date.now() - start;
                    if (timePassed >= animationTime) {
                      clearInterval(timer); // finish the animation after 2 seconds
                      return;
                    }
                    // draw the animation at the moment timePassed
                    draw(timePassed);
                  }, 10);
                }
                else{
                  sectionContentWrapper.classList.add("section-has-animated");
                  let draw = (timer) => {
                    let proportion = timer / animationTime;
                    let height = Math.floor(sectionContentWrapper.scrollHeight * proportion);
                    sectionContentWrapper.style.height = height + "px";
                    sectionContentWrapper.style.opacity = proportion + "";
                  }
                  //this creates the function that animates the titles and section contents
                  const start = Date.now();
                  let timer = setInterval(function () {
                    // how much time passed from the start
                    let timePassed = Date.now() - start;
                    if (timePassed >= animationTime) {
                      clearInterval(timer); // finish the animation after 2 seconds
                      return;
                    }
                    // draw the animation at the moment timePassed
                    draw(timePassed);
                  }, 10);
                }
              }
            }
        },
        mounted() {
          const animationTime = 1300;
          let titleContainers = document.getElementsByClassName('titleContainer') //the containers that hold the titles
          // console.log("titleContainers: ", titleContainers);
          let sectionContainers = document.getElementsByClassName("sectionContentContainer");
          //console.log("sectionContainers: ", sectionContainers);
          //add the animated class to each sectionContainer
          sectionContainers.forEach((element) => {
            element.classList.add("section-has-animated");
          });

          let draw = (timer) => {
            //console.log("timer:", timer);
            titleContainers.forEach((element) => {
              let proportion = timer/animationTime;
              let height = Math.floor(element.scrollHeight * proportion);
              element.style.height = height + "px";
              element.style.opacity = proportion + "";
            });
            sectionContainers.forEach((element) => {
              let proportion = timer/animationTime;
              // console.log("proportion: ", proportion);
              let height = Math.floor(element.scrollHeight * proportion) + 5;
              element.style.height = height + "px";
              element.style.opacity = proportion + "";
            });
          }
          //this creates the function that animates the titles and section contents
          const start = Date.now();
          let timer = setInterval(function() {
            // how much time passed from the start
            let timePassed = Date.now() - start;
            if (timePassed >= animationTime) {
              clearInterval(timer); // finish the animation after 2 seconds
              return;
            }
            // draw the animation at the moment timePassed
            draw(timePassed);
          }, 10);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1{
        padding: 0 !important;
        margin: 0 !important;
        font-size: xx-large;
        color: #9575a9;
        font-weight: bold;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }
    li {
        display: inline-block;
        margin: 0 10px;
    }

    p{
        padding: 0.5em
    }
    a {
        color: #42b983;
        padding:5px;
        border-radius: 5px;
        font-size: larger;
    }
    a:hover {
        cursor: pointer;
        background: #42b983;
        color: black;
    }

    img{
        border-radius: 4px;
    }

    #root{
        display: grid;
        grid-template-columns: 100% 10%;
        z-index: 1;
    }

    #rightColumn{
        display: none;
    }

    .titleContainer{
      margin: 70px 0 50px 0;
      text-align: center;
      overflow: hidden;
      height: 0;
      opacity: 0;
    }

    .sectionContentContainer{
      height: 0;
      opacity: 0;
      overflow: hidden;
    }

    .sectionTitle {
      font-size: xx-large;
      color: black;
      background: #42b983;
      width: fit-content;
      padding-left: 5px;
      padding-right: 5px;
      border-radius: 5px;
    }

    .sectionTitle:hover{
        cursor: pointer;
        color: #42b983;
        background: #333333;
    }

    .clickable{
        color: #42b983;
        padding: 5px 15px !important;
        border-radius: 5px;
        display: inline-block;
        font-size: larger;
    }

    .clickable:hover{
        cursor: pointer;
        background: #42b983;
        color: black;
        padding: 5px 15px !important;
    }

    .clickableContent{
        color: #42b983;
        border-radius: 5px;
        display: inline-block;
        font-size: larger;
    }

    .clickableContent:hover{
        cursor: pointer;
        background: #42b983;
        color: black;
    }

    .clickableImg:hover{
        cursor: pointer;
        background-color: #42b983;
    }

    #aboutContent a{
        font-size: large !important;
    }

    .projectContainer{
        width: 100%;
    }

    .projectTitle{
        margin: 30px;
        font-size: x-large;
        padding-left: 0;
        color: #6296ba;
        font-weight: bold;
    }
    #ateBallImg{
        padding: 5px;
        border-radius: 25px
    }

    .projectContent{
        text-align: center;
        padding: 5px;
    }
    .projectContent a{
        padding: 0;
        text-align: center;
        font-size: large !important;
    }


    /*old shit i dont think i use anymore*/
    .navBar {
        background-color: #333;
        position: fixed;
        right: 0;
        border-radius: 5px;
    }

    /* Links inside the navbar */
    .navBar a {
        float: right;
        display: block;
        color: #42b983;
        text-align: center;
        padding: 14px;
        text-decoration: none;
        border-radius: 5px;
        margin-top: 5px;
        font-size: large;
    }
    /* Change background on mouse-over */
    .navBar a:hover {
        background: #42b983;
        color: black;
    }
</style>